export const PAGE_TITLE = "Success Stories";
export const PAGE_SINGLE_TITLE = "Success Story";
export const LINK_URL = "success-stories";
export const SEARCH_TERMS = ["name"];
export const inputFields = {
  name: {
    type: "string",
    required: true,
    title: "Name",
    slug: true,
    inputType: "text",
  },
  age: {
    type: "string",
    required: true,
    title: "Age",
  },
  disease: {
    type: "string",
    required: false,
    title: "Disease",
  },
  money_spent: {
    type: "string",
    required: false,
    title: "Money Spent",
    inputType: "number",
  },
  content: {
    type: "html",
    required: false,
    title: "Content",
  },
  image: {
    type: "file",
    required: false,
    title: "Image",
  },
  document: {
    type: "gallery",
    required: false,
    title: "Document",
  },

  slug: {
    type: "slug",
    required: false,
    targetField: "title",
    title: "Slug",
  },
};
export const initialValues = {
  name: "",
  age: "",
  disease: "",
  content: "",
  slug: "",
  money_spent: "",
};

export const view_all_table = [
  { name: "Name", value: "name" },
  { name: "Age", value: "age" },
  { name: "Disease", value: "disease" },
  { name: "Slug", value: "slug" },
];
